import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { agregarTarea } from "../../../features/registroTareasSlice";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Material UI y Lucide
import { 
  Box, Typography, TextField, Grid, Button, Paper, 
  FormControlLabel, Checkbox, Stack, Divider,Chip
} from "@mui/material";
import { 
  PlusCircle, Calendar, MapPin, Users, Info, 
  Mic2, Utensils, Monitor, Camera, Video 
} from "lucide-react";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const PALETTE = { 
  ice: "#C2EDF0", 
  aqua: "#00C0CA", 
  teal: "#008B9C", 
  dark: "#22404D", 
  slate: "#94A3B8",
  pearl: "#EEF3F4"
};

const Evento = ({ idPedido }) => {
    // ==========================================
    // LÓGICA ORIGINAL (MANTENIDA)
    // ==========================================
    const tareas = useSelector(state => state.tareas.Tareas);
    const dispatch = useDispatch();

    const [formEvento, setFormEvento] = useState({
        tipoTarea: "Evento",
        cantidadPersonas: 0,
        fecha: "",
        catering: false,
        estado: "Pendiente",
        lugar: "",
        audio: false,
        pantalla: false,
        coberturaFoto: false,
        coberturaVideo: false,
        tipo: "",
    });

    const [mostrarFormulario, setMostrarFormulario] = useState(true);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormEvento({
            ...formEvento,
            [name]: type === "checkbox" ? checked : value
        });
    };

    const validar = () => {
        const { cantidadPersonas, lugar, tipo, fecha } = formEvento;
        const fechaFormulario = new Date(fecha);
        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0);
        fechaFormulario.setHours(0, 0, 0, 0);

        if (cantidadPersonas <= 0) return "Ingrese cantidad de personas";
        if (!lugar) return "Ingrese locación del evento";
        if (fechaFormulario < fechaActual) return "La fecha de realización debe ser una fecha futura.";
        if (!tipo) return "Ingrese el tipo de evento";
        return ""; 
    };

    const agregarTareaAlPedido = async () => {
        const mensaje = validar();
        if (mensaje !== "") {
            toast.error(mensaje, { position: "bottom-center", autoClose: 3000 });
            return;
        }

        const registro = {
            id: tareas.length + 1,
            comentario:"",           
            ...formEvento,       
        };
        registro.cantidadPersonas = parseInt(registro.cantidadPersonas, 10);

        if (idPedido !== 0) {   
            const respuesta = await fetch(`${apiUrl}/Tarea/AgregarTareaEvento?IdPedido=${idPedido}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'apiKey': localStorage.getItem("apiKey") 
                },
                body: JSON.stringify(registro)
            });

            if (respuesta.ok) {
                setMostrarFormulario(false);               
                toast.success('Pedido agregado correctamente', { position: "bottom-center", autoClose: 3000 });             
            } else {
                toast.error('Error al agregar el pedido', { position: "bottom-center", autoClose: 3000 });
            }
        } else {
            dispatch(agregarTarea(registro));
            setMostrarFormulario(false);
            toast.success('Tarea agregada correctamente', { position: "bottom-center", autoClose: 3000 });
        }
    };
    // ==========================================

    if (!mostrarFormulario) return null;

    return (
        <Paper 
            elevation={0} 
            sx={{ 
                p: 3, 
                borderRadius: '24px', 
                bgcolor: PALETTE.pearl, 
                border: `1px solid ${PALETTE.ice}`,
                mt: 2,
                animation: 'fadeIn 0.3s ease-in-out'
            }}
        >
            <Stack spacing={2.5}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Calendar size={20} color={PALETTE.teal} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: PALETTE.dark }}>
                        Detalles del Evento
                    </Typography>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="caption" sx={{ fontWeight: 800, ml: 1, color: PALETTE.slate }}>TIPO DE EVENTO</Typography>
                        <TextField 
                            fullWidth 
                            name="tipo" 
                            value={formEvento.tipo} 
                            onChange={handleChange} 
                            placeholder="Ej: Taller, Charla, Feria"
                            sx={{ mt: 0.5, "& .MuiOutlinedInput-root": { borderRadius: '12px', bgcolor: 'white' } }} 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="caption" sx={{ fontWeight: 800, ml: 1, color: PALETTE.slate }}>FECHA REALIZACIÓN</Typography>
                        <TextField 
                            fullWidth 
                            type="date" 
                            name="fecha" 
                            value={formEvento.fecha} 
                            onChange={handleChange} 
                            inputProps={{ min: new Date().toISOString().split('T')[0] }}
                            sx={{ mt: 0.5, "& .MuiOutlinedInput-root": { borderRadius: '12px', bgcolor: 'white' } }} 
                        />
                    </Grid>

                    <Grid item xs={12} sm={8}>
                        <Typography variant="caption" sx={{ fontWeight: 800, ml: 1, color: PALETTE.slate }}>LUGAR / LOCACIÓN</Typography>
                        <TextField 
                            fullWidth 
                            name="lugar" 
                            value={formEvento.lugar} 
                            onChange={handleChange} 
                            placeholder="Ej: Hotel Sheraton, Aula 4"
                            InputProps={{ startAdornment: <MapPin size={16} style={{marginRight: 8, color: PALETTE.slate}} /> }}
                            sx={{ mt: 0.5, "& .MuiOutlinedInput-root": { borderRadius: '12px', bgcolor: 'white' } }} 
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ fontWeight: 800, ml: 1, color: PALETTE.slate }}>ASISTENTES</Typography>
                        <TextField 
                            fullWidth 
                            type="number" 
                            name="cantidadPersonas" 
                            value={formEvento.cantidadPersonas} 
                            onChange={handleChange} 
                            InputProps={{ startAdornment: <Users size={16} style={{marginRight: 8, color: PALETTE.slate}} /> }}
                            sx={{ mt: 0.5, "& .MuiOutlinedInput-root": { borderRadius: '12px', bgcolor: 'white' } }} 
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Divider sx={{ my: 1 }}><Chip label="Servicios Requeridos" size="small" sx={{ fontWeight: 700, bgcolor: PALETTE.ice, color: PALETTE.teal }} /></Divider>
                    </Grid>

                    {/* Checkboxes estilizados */}
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            {[
                                { name: "catering", label: "Catering", icon: <Utensils size={16}/> },
                                { name: "audio", label: "Equipo de Audio", icon: <Mic2 size={16}/> },
                                { name: "pantalla", label: "Pantalla / Proyector", icon: <Monitor size={16}/> },
                                { name: "coberturaFoto", label: "Fotos", icon: <Camera size={16}/> },
                                { name: "coberturaVideo", label: "Video", icon: <Video size={16}/> },
                            ].map((item) => (
                                <Grid item xs={6} sm={4} key={item.name}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox 
                                                name={item.name} 
                                                checked={formEvento[item.name]} 
                                                onChange={handleChange}
                                                sx={{ color: PALETTE.teal, '&.Mui-checked': { color: PALETTE.teal } }}
                                            />
                                        }
                                        label={
                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                {item.icon}
                                                <Typography variant="body2" sx={{ fontWeight: 600, color: PALETTE.dark }}>{item.label}</Typography>
                                            </Box>
                                        }
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>

                <Button 
                    variant="contained" 
                    fullWidth 
                    onClick={agregarTareaAlPedido}
                    startIcon={<PlusCircle size={18} />}
                    sx={{ 
                        mt: 1, 
                        borderRadius: '12px', 
                        py: 1.2, 
                        fontWeight: 800, 
                        bgcolor: PALETTE.teal,
                        '&:hover': { bgcolor: PALETTE.dark }
                    }}
                >
                    Añadir Evento al Pedido
                </Button>
            </Stack>
        </Paper>
    );
};

export default Evento;